//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "privacy",
    data(){
        return{
            showPrivacy:true
        }
    },
    methods:{
        closePrivacy(){
            this.$emit('closePrivacy');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/privacy.vue